import './Chave.css';

type Props = {
  /** O nome do que a chave liga — o leitor de tela anuncia "<rótulo>, ligado". */
  readonly rotulo: string;
  readonly ligada: boolean;
  /** Quem chama decide: alternar na hora ou confirmar antes. */
  readonly aoAlternar: () => void;
  readonly desabilitada?: boolean;
};

/**
 * Chave liga/desliga.
 *
 * `role="switch"` num `<button>` de verdade: teclado e foco vêm de graça, e o
 * estado vai em `aria-checked`. O texto Ligada/Desligada fica ao lado da
 * chave — a posição da bolinha, sozinha, significaria só por cor e forma
 * (RNF-022).
 */
export function Chave({ rotulo, ligada, aoAlternar, desabilitada = false }: Props) {
  return (
    <span className="chave">
      <button
        type="button"
        role="switch"
        aria-checked={ligada}
        aria-label={rotulo}
        className={ligada ? 'chave__trilho chave__trilho--ligada' : 'chave__trilho'}
        disabled={desabilitada}
        onClick={aoAlternar}
      >
        <span className="chave__bolinha" aria-hidden="true" />
      </button>
      <span className="chave__estado" aria-hidden="true">
        {ligada ? 'Ligada' : 'Desligada'}
      </span>
    </span>
  );
}
